/**
 * Тумблер бота «без белых списков, обходов и анонимности»: точечные правки наших текстов.
 *
 * Пары «было → стало» по ключу, а не полные копии: правка в `ru.ts` / `en.ts` не
 * теряется, а пару, которой больше нечего менять, ловит `npm run lint`
 * (`scripts/check-i18n.mjs`). Накладываются при включённом тумблере (`setHideWhitelist`
 * в `i18n.ts`), поверх них ещё идёт автозамена `lib/whitelist-wording.ts`. Ключи,
 * переписанные партнёром, не трогаем. Бэк держит такие же правки для бота в
 * `src/shared/i18n/neutral.json`, а дефолт «No logs» для кабинета в `webapp_catalog.py`.
 */
const neutral: Record<'ru' | 'en', Record<string, [string, string][]>> = {
  "ru": {
    "No logs": [
      [
        "Строго без логов",
        "Стабильное соединение"
      ]
    ],
    "Referral share text": [
      [
        "быстро и без логов",
        "быстро и стабильно"
      ]
    ],
    "Feature private": [
      [
        "Приватно",
        "Стабильно"
      ]
    ],
    "Feature private hint": [
      [
        "Без логов трафика",
        "Без обрывов соединения"
      ]
    ],
    "Plans bypass title": [
      [
        "Работает там, где блокируют",
        "Быстро даже на мобильном"
      ]
    ],
    "Whitelist scarce note": [
      [
        "в дефиците: РКН блокирует их всё чаще. Чтобы",
        "в дефиците. Чтобы"
      ]
    ]
  },
  "en": {
    "No logs": [
      [
        "Strict No-Logs Policy",
        "Stable connection"
      ]
    ],
    "Connect other devices desc": [
      [
        "shows the whitelist-bypass servers",
        "shows the internet booster servers"
      ]
    ],
    "FAQ about fallback": [
      [
        "fast, private access",
        "fast and stable access"
      ]
    ],
    "Plan devices unlim gb": [
      [
        "GB for restricted sites",
        "GB of booster traffic"
      ]
    ],
    "Referral share text": [
      [
        "fast and no logs",
        "fast and stable"
      ]
    ],
    "Traffic bypass left": [
      [
        "Left for restricted sites",
        "Booster traffic left"
      ]
    ],
    "Traffic note trial": [
      [
        "The trial has no servers for restricted sites",
        "The trial has no booster servers"
      ]
    ],
    "Traffic note paid": [
      [
        "only to servers for restricted sites",
        "only to booster servers"
      ]
    ],
    "Feature private": [
      [
        "Private",
        "Stable"
      ]
    ],
    "Feature private hint": [
      [
        "No traffic logs",
        "No connection drops"
      ]
    ],
    "Plans bypass title": [
      [
        "Works where others are blocked",
        "Fast even on mobile"
      ]
    ],
    "Plans bypass desc": [
      [
        "Gets through allow-lists and mobile-internet throttling",
        "Speeds up mobile internet"
      ]
    ],
    "GB for bypass": [
      [
        "GB for restricted sites",
        "GB of booster traffic"
      ]
    ],
    "Trial bypass note": [
      [
        "The trial has no servers for restricted sites or throttled mobile internet",
        "The trial has no mobile internet booster servers"
      ]
    ],
    "Whitelist test done": [
      [
        "Restricted-sites test used",
        "Booster test used"
      ]
    ],
    "Whitelist test buy": [
      [
        "Restricted-sites test",
        "Booster test"
      ]
    ],
    "Whitelist used note": [
      [
        "the bypass servers have",
        "the booster servers have"
      ]
    ],
    "Whitelist scarce note": [
      [
        "Servers for restricted sites are scarce: they get blocked more and more often. So that",
        "Booster servers are scarce. So that"
      ]
    ],
    "Whitelist test sub gb": [
      [
        "GB for restricted sites",
        "GB of booster traffic"
      ]
    ],
    "Renew whitelist note": [
      [
        "bypass servers are scarce",
        "booster servers are scarce"
      ]
    ],
    "Renew whitelist name": [
      [
        "restricted-sites test",
        "booster test"
      ]
    ],
    "Lifetime bypass traffic": [
      [
        "Fresh whitelist bypasses",
        "Fresh internet booster"
      ]
    ],
    "Trial lifetime option note": [
      [
        "fresh whitelist bypasses",
        "a fresh internet booster"
      ],
      [
        "100 MB of bypass",
        "100 MB of booster"
      ]
    ],
    "Traffic note lifetime": [
      [
        "Bypass traffic never expires",
        "Booster traffic never expires"
      ]
    ],
    "Lifetime traffic desc": [
      [
        "your whitelist bypass balance",
        "your booster balance"
      ]
    ],
    "Addon done traffic": [
      [
        "GB of whitelist bypass traffic",
        "GB of internet booster traffic"
      ]
    ],
    "Countries limited": [
      [
        "whitelist bypass:",
        "internet booster:"
      ]
    ]
  }
};

export default neutral;
